import { createClient } from '@base44/sdk';
// import { getAccessToken } from '@base44/sdk/utils/auth-utils';

// Create a client WITHOUT requiresAuth to prevent auto-redirects
// Authentication is handled by our own backend API
export const base44 = createClient({
  appId: "68d02d32902df753d69e6b12", 
  requiresAuth: false // Disabled to prevent auto-redirects - auth handled by backend
});
